import { useState } from 'react'
import { Link } from 'react-router-dom'
import { lookupWhistle, submitWhistle, type WhistleCategory, type WhistlePublic } from '../lib/api'
import { thaiDateTime } from '../lib/format'

const categories: { value: WhistleCategory; label: string }[] = [
  { value: 'fraud', label: 'การทุจริต / ยักยอก' },
  { value: 'bribery', label: 'สินบน / ผลประโยชน์ทับซ้อน' },
  { value: 'harassment', label: 'การล่วงละเมิด' },
  { value: 'safety', label: 'ความปลอดภัย / สิ่งแวดล้อม' },
  { value: 'other', label: 'อื่น ๆ' },
]

const statusLabel: Record<string, string> = {
  received: 'รับเรื่องแล้ว',
  reviewing: 'อยู่ระหว่างตรวจสอบ',
  closed: 'ปิดเรื่อง',
}

export function WhistlePublic() {
  const [category, setCategory] = useState<WhistleCategory>('fraud')
  const [detail, setDetail] = useState('')
  const [contact, setContact] = useState('')
  const [evidence, setEvidence] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const [code, setCode] = useState('')
  const [copied, setCopied] = useState(false)

  const [lookupCode, setLookupCode] = useState('')
  const [found, setFound] = useState<WhistlePublic | null>(null)
  const [lookupErr, setLookupErr] = useState('')

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setErr('')
    if (detail.trim().length < 20) { setErr('กรุณาอธิบายเหตุการณ์อย่างน้อย 20 ตัวอักษร'); return }
    setBusy(true)
    try {
      const res = await submitWhistle({ category, detail, contact, evidence_note: evidence })
      setCode(res.tracking_code)
      setDetail(''); setContact(''); setEvidence('')
    } catch (e) {
      setErr((e as Error).message)
    } finally {
      setBusy(false)
    }
  }

  async function lookup(e: React.FormEvent) {
    e.preventDefault()
    setLookupErr(''); setFound(null)
    try {
      setFound(await lookupWhistle(lookupCode.trim().toUpperCase()))
    } catch (e) {
      setLookupErr((e as Error).message)
    }
  }

  if (code) {
    return (
      <div className="public-wrap">
        <div className="card card-pad" style={{ maxWidth: 560 }}>
          <div className="card-label">รับเรื่องแล้ว</div>
          <h1 style={{ margin: '10px 0 6px', fontSize: 22, fontWeight: 500 }}>รหัสติดตามของคุณ</h1>
          <p className="dim" style={{ fontSize: 13, lineHeight: 1.7 }}>
            ระบบแสดงรหัสนี้เพียงครั้งเดียว กรุณาบันทึกไว้เพื่อตรวจสอบความคืบหน้า
            เราไม่เก็บชื่อ ไอพี หรือข้อมูลอุปกรณ์ของผู้แจ้ง
          </p>
          <div className="tracking-code">{code}</div>
          <div className="row" style={{ gap: 10, marginTop: 16 }}>
            <button className="btn btn-primary" onClick={async () => {
              await navigator.clipboard.writeText(code)
              setCopied(true); setTimeout(() => setCopied(false), 2000)
            }}>{copied ? 'คัดลอกแล้ว' : 'คัดลอกรหัส'}</button>
            <Link className="btn" to="/login">กลับสู่ระบบ</Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="public-wrap">
      <div className="public-grid">
        <form className="card card-pad" onSubmit={submit}>
          <div className="card-label">ช่องทางแจ้งเบาะแส</div>
          <h1 style={{ margin: '10px 0 4px', fontSize: 24, fontWeight: 500, letterSpacing: '-0.02em' }}>แจ้งเรื่องโดยไม่ระบุตัวตน</h1>
          <p className="dim" style={{ fontSize: 13, lineHeight: 1.7, marginBottom: 18 }}>
            เรื่องจะส่งตรงถึงคณะกรรมการตรวจสอบ ไม่บันทึกไอพีหรือข้อมูลอุปกรณ์
          </p>

          <div className="field">
            <label htmlFor="w-cat">ประเภทเรื่อง</label>
            <select id="w-cat" className="input" value={category} onChange={(e) => setCategory(e.target.value as WhistleCategory)}>
              {categories.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>

          <div className="field">
            <label htmlFor="w-detail">รายละเอียด</label>
            <textarea id="w-detail" className="input" rows={7} value={detail} onChange={(e) => setDetail(e.target.value)}
              placeholder="发生了什么 ที่ไหน เมื่อใด ใครเกี่ยวข้อง และมีหลักฐานอะไร" />
            <small className="dim" style={{ fontSize: 11 }}>{detail.trim().length}/5000 ตัวอักษร (อย่างน้อย 20)</small>
          </div>

          <div className="field">
            <label htmlFor="w-contact">ช่องทางติดต่อกลับ (ไม่บังคับ)</label>
            <input id="w-contact" className="input" value={contact} onChange={(e) => setContact(e.target.value)} placeholder="อีเมลหรือเบอร์โทร" />
          </div>

          <div className="field">
            <label htmlFor="w-evidence">หมายเหตุหลักฐาน (ไม่บังคับ)</label>
            <input id="w-evidence" className="input" value={evidence} onChange={(e) => setEvidence(e.target.value)} placeholder="เช่น เอกสารเลขที่ EXP-2609-011" />
          </div>

          {err && <div className="form-error">{err}</div>}
          <button className="btn btn-primary" disabled={busy} type="submit" style={{ marginTop: 8 }}>
            {busy ? 'กำลังส่ง…' : 'ส่งเรื่อง'}
          </button>
        </form>

        <div className="card card-pad">
          <div className="card-label">ติดตามเรื่องที่แจ้งไว้</div>
          <form onSubmit={lookup} style={{ marginTop: 12 }}>
            <div className="field">
              <label htmlFor="w-code">รหัสติดตาม 12 ตัวอักษร</label>
              <input id="w-code" className="input mono" value={lookupCode} onChange={(e) => setLookupCode(e.target.value.toUpperCase())}
                placeholder="เช่น 3B794B9C5WAQ" maxLength={14} />
            </div>
            <button className="btn" type="submit" disabled={lookupCode.trim().length < 12}>ตรวจสอบสถานะ</button>
          </form>

          {lookupErr && <div className="form-error" style={{ marginTop: 12 }}>{lookupErr}</div>}

          {found && (
            <div style={{ marginTop: 18 }}>
              <div className="row" style={{ justifyContent: 'space-between' }}>
                <b>{statusLabel[found.status] ?? found.status}</b>
                <span className="dim" style={{ fontSize: 11.5 }}>{thaiDateTime(found.created_at)}</span>
              </div>
              <ol className="timeline" style={{ marginTop: 12 }}>
                {found.timeline.map((t, i) => (
                  <li key={i}>
                    <span className="dot" />
                    <div>
                      <div style={{ fontSize: 13 }}>{statusLabel[t.status] ?? t.status}</div>
                      <div className="dim" style={{ fontSize: 11.5 }}>{thaiDateTime(t.at)}</div>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          )}
        </div>
      </div>
      <div className="dim" style={{ fontSize: 11.5, marginTop: 18, textAlign: 'center' }}>
        ระบบไม่เก็บไอพี ยูสเอเจนต์ หรือข้อมูลที่ระบุตัวผู้แจ้ง · เก็บเฉพาะแฮชของรหัสติดตาม
      </div>
    </div>
  )
}
